import React, { useState, useEffect } from "react";
import { Box, Button, Dialog, DialogTitle, DialogActions, IconButton, styled } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import { useSelector, useDispatch } from "react-redux";
import { UpdateReject } from "./../../../Redux/action/JobDescriptionAction";
import { JobsInterviewPlannedAcceptAction } from "../../../Redux/action/JobsInterviewPlannedAcceptAction";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

const RejectJob = (props) => {
    const { userResult } = useSelector((state) => state.Auth);
    const [open, setOpen] = useState(false);

    const [data, setData] = useState({
        declinedReason: "",
    });

    const { declinedReason } = data;

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    let dispatch = useDispatch();

    const handleInputChange = (e) => {
        let { name, value } = e.target;
        setData({ ...data, [name]: value });
    };

    const candidateId = userResult?.userid;;
    const jobId = props.data
    const appliedJobsId = props.appliedJobsId
    const interviewId = props.interviewData
    const interviewerData = props.interviewerData

    const handleSubmit = (e) => {
        e.preventDefault();
        if((interviewId == "" || interviewId == null ) && (interviewerData == "" || interviewerData == null)){
            let content = {
                appliedJobsId,
                jobAcceptanceStatus:"REJECTED",
                declinedReason
            }
            dispatch(UpdateReject(content));
        }else if(interviewerData == "" || interviewerData == null){
            const content = {
                interviewId,
                isAcceptedByCandidate:"REJECTED",
                declineReasonCandidate:declinedReason
            }
            dispatch(JobsInterviewPlannedAcceptAction(content));
        }else{
            const content = {
                interviewId:interviewerData,
                isAcceptedByInterviewer:"REJECTED",
                declineReasonInterviewer:declinedReason
            }
            dispatch(JobsInterviewPlannedAcceptAction(content));
        }
    };

    return (
        <>
            <ToastContainer />
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    onClose={handleClose}
                >
                    Please Write Your Reasons
                </BootstrapDialogTitle>
                <form onSubmit={handleSubmit}>
                    <Box
                        sx={{
                            width: 500,
                            maxWidth: "100%",
                        }}
                    >
                        <TextField
                            fullWidth
                            label="Please Write Your Reasons"
                            value={declinedReason}
                            name="declinedReason"
                            onChange={handleInputChange}
                            required
                        />
                        {/* <div className="label_job_schedule">
                            <select
                                required
                                className="form-controll Select"
                                name="shiftTime"
                                value={shiftTime}
                                onChange={handleInputChange}
                            >
                                <option className="dropdown_option">Select Shift Timing</option>
                                <option className="dropdown_option" value="DAY_SHIFT">Day_Shift</option>
                                <option className="dropdown_option" value="NIGHT_SHIFT">Night_Shift</option>
                            </select>
                        </div> */}
                    </Box>
                    <DialogActions>
                        <Button autoFocus type="submit">
                            Submit
                        </Button>
                    </DialogActions>
                </form>
            </BootstrapDialog>
            <div onClick={handleClickOpen}>Reject</div>
        </>
    );
};

export default RejectJob;
